export default "__VITE_PUBLIC_ASSET__12a0a6e7__"